import { makeStyles } from '@material-ui/core/styles'
import { grey } from '@material-ui/core/colors'
import Typography from '@material-ui/core/Typography'
import DialogContent from '@material-ui/core/DialogContent'
import { range, truncate } from '~/tools/utils'
import OrderProgress from './OrderProgress'
import { ORDER_DISPLAY_MODES } from './OrderProcessor'
import { extractFulfillmentLineItemInfo } from './utils'

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        display: 'flex',
    },
    allAtOnceContainer: {
        width: '100%',
    },
    fulfillmentLineItems: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    fulfillmentLineItem: {
        display: 'flex',
        width: 'calc(50% - 15px)',
        padding: 15,
        marginRight: 15,
        marginBottom: 15,
        border: '1px solid lightgray',
        borderRadius: 5,
    },
    fulfillmentLineItemHighlighted: {
        borderColor: theme.palette.primary.main,
    },
    coverImageAllAtOnce: {
        width: '8vw',
        minWidth: '8vw',
        marginRight: 20,
    },
    allAtOnceRightSection: {},
    productNameAllAtOnce: {
        fontSize: '0.9rem !important',
    },
    stockUnitSectionAllAtOnce: {
        display: 'flex',
        marginTop: 10,
    },
    stockUnitSubSectionAllAtOnce: {
        marginRight: 20,
    },
    stockUnitSubSectionTitleAllAtOnce: {
        color: grey[500],
        fontSize: '0.9rem !important',
    },
    stockUnitSubSectionTextAllAtOnce: {
        fontSize: '0.9rem !important',
    },
    progressSectionAllAtOnce: {
        marginTop: 10,
    },
    sliProgressMeter: {
        display: 'flex',
        flex: '1 0 auto',
    },
    sliProgressMeterSegment: {
        backgroundColor: grey[300],
        marginRight: 3,
        height: 5,
        flex: '1 0 auto',
    },
    sliProgressMeterSegmentActive: {
        backgroundColor: theme.palette.primary.main,
    },
    sliUnitsNeeded: {
        fontSize: '0.9rem !important',
        marginTop: 3,
    },
}))

const AllAtOnceProcessing = ({
    fulfillment,
    sale,
    language,
    scannedFulfillmentLineItemID,
    currentFulfillmentLineItemIndex,
    currentItemUnitIndex,
    handleItemUnitSelect,
}) => {
    const classes = useStyles()

    if (!fulfillment || !sale) {
        return <DialogContent className={classes.dialogContent} />
    }

    return (
        <DialogContent className={classes.dialogContent}>
            <div className={classes.allAtOnceContainer}>
                <OrderProgress
                    fulfillment={fulfillment}
                    currentFulfillmentLineItemIndex={currentFulfillmentLineItemIndex}
                    currentItemUnitIndex={currentItemUnitIndex}
                    onItemUnitSelect={handleItemUnitSelect}
                    orderDisplayMode={ORDER_DISPLAY_MODES.ALL_AT_ONCE}
                />
                <div className={classes.fulfillmentLineItems}>
                    {fulfillment.fulfillment_line_items.map((fli) => {
                        const saleLineItem = sale.sale_line_items.find(
                            (sli) => sli.id === fli.sale_line_item
                        )
                        const itemInfo = extractFulfillmentLineItemInfo(fli, sale, language)

                        return (
                            <div
                                className={`${classes.fulfillmentLineItem} ${
                                    scannedFulfillmentLineItemID === fli.id
                                        ? classes.fulfillmentLineItemHighlighted
                                        : ''
                                }`}
                                key={fli.id}
                            >
                                <img
                                    className={classes.coverImageAllAtOnce}
                                    src={
                                        saleLineItem?.stock_unit?.product?.cover_image_url ||
                                        saleLineItem.image
                                    }
                                    alt="Product"
                                />
                                <div className={classes.allAtOnceRightSection}>
                                    <Typography className={classes.productNameAllAtOnce}>
                                        {truncate(itemInfo.productName, 100)}
                                    </Typography>
                                    <div className={classes.stockUnitSectionAllAtOnce}>
                                        <div className={classes.stockUnitSubSectionAllAtOnce}>
                                            <Typography
                                                className={
                                                    classes.stockUnitSubSectionTitleAllAtOnce
                                                }
                                                variant="h5"
                                            >
                                                {gettext('SKU')}
                                            </Typography>
                                            <Typography
                                                className={classes.stockUnitSubSectionTextAllAtOnce}
                                                variant="h5"
                                            >
                                                {itemInfo.sku}
                                            </Typography>
                                        </div>
                                        {itemInfo.skuName && (
                                            <div className={classes.stockUnitSubSectionAllAtOnce}>
                                                <Typography
                                                    className={
                                                        classes.stockUnitSubSectionTitleAllAtOnce
                                                    }
                                                    variant="h5"
                                                >
                                                    {gettext('SKU name')}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.stockUnitSubSectionTextAllAtOnce
                                                    }
                                                    variant="h5"
                                                >
                                                    {itemInfo.skuName}
                                                </Typography>
                                            </div>
                                        )}
                                        {itemInfo.barcode && (
                                            <div className={classes.stockUnitSubSectionAllAtOnce}>
                                                <Typography
                                                    className={
                                                        classes.stockUnitSubSectionTitleAllAtOnce
                                                    }
                                                    variant="h5"
                                                >
                                                    {gettext('Barcode')}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.stockUnitSubSectionTextAllAtOnce
                                                    }
                                                    variant="h5"
                                                >
                                                    {itemInfo.barcode}
                                                </Typography>
                                            </div>
                                        )}

                                        {itemInfo.serialNumbers && (
                                            <div className={classes.stockUnitSubSectionAllAtOnce}>
                                                <Typography
                                                    className={
                                                        classes.stockUnitSubSectionTitleAllAtOnce
                                                    }
                                                    variant="h5"
                                                >
                                                    {gettext('Serial numbers')}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.stockUnitSubSectionTextAllAtOnce
                                                    }
                                                    variant="h5"
                                                >
                                                    {itemInfo.serialNumbers.join(', ')}
                                                </Typography>
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.progressSectionAllAtOnce}>
                                        <div className={classes.sliProgressMeter}>
                                            {range(0, fli.quantity).map((index) => (
                                                <div
                                                    className={`${classes.sliProgressMeterSegment} ${
                                                        index < fli.numPacked
                                                            ? classes.sliProgressMeterSegmentActive
                                                            : ''
                                                    }`}
                                                    key={index}
                                                />
                                            ))}
                                        </div>
                                        <Typography className={classes.sliUnitsNeeded}>
                                            {interpolate(gettext('%s of %s'), [
                                                fli.numPacked,
                                                fli.quantity,
                                            ])}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </DialogContent>
    )
}

export default AllAtOnceProcessing
